class ProductCardPurchase extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.updateVariant);
    this.updateVariant();
    customElements.whenDefined('product-card').then(() => {
      if (this.isConnected) this.updateVariant();
    });
    customElements.whenDefined('slideshow-component').then(() => {
      if (this.isConnected) this.updateImage();
    });
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.updateVariant);
  }

  get selectedOption() {
    return this.querySelector('[data-card-variant-select]')?.selectedOptions[0];
  }

  get selectedMediaId() {
    return this.selectedOption?.dataset.mediaId;
  }

  updateVariant = () => {
    const option = this.selectedOption;
    if (!option) return;
    const form = this.querySelector('form');
    const variantInput = form?.querySelector('[name="id"]');
    const quantityInput = form?.querySelector('[name="quantity"]');
    const button = form?.querySelector('[name="add"]');
    const label = this.querySelector('[data-card-add-label]');
    const price = this.querySelector('product-price [ref="priceContainer"]');
    const available = option.dataset.available === 'true';
    if (variantInput) variantInput.value = option.value;
    if (quantityInput) quantityInput.value = option.dataset.quantity || '1';
    if (button) button.disabled = !available;
    if (label) label.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
    if (price && option.dataset.price) {
      const template = document.createElement('template');
      template.innerHTML = option.dataset.price;
      const replacement = template.content.querySelector('[ref="priceContainer"]');
      if (replacement) price.replaceChildren(...replacement.childNodes);
      const priceComponent = price.closest('product-price');
      priceComponent?.querySelector('[ref="volumePricingNote"]')?.remove();
      const note = template.content.querySelector('[ref="volumePricingNote"]');
      if (note) price.after(note);
      price.setAttribute('aria-live', 'polite');
    }
    this.querySelector('[ref="addToCartTextError"]')?.classList.add('hidden');
    const card = this.closest('product-card');
    card?.applyVariantToLinks?.(option.value);
    this.updateImage();
  };

  updateImage() {
    const option = this.selectedOption;
    const card = this.closest('product-card');
    if (!option || !card) return;
    const slideshow = card.querySelector('[ref="slideshow"]');
    const mediaId = option.dataset.mediaId;
    const slides = [...(slideshow?.querySelectorAll('slideshow-slide') || [])];
    const selectedSlide = slides.find((slide) => slide.getAttribute('slide-id') === mediaId);
    if (selectedSlide) {
      for (const slide of slides) {
        if (slide.hasAttribute('variant-image')) slide.hidden = slide !== selectedSlide;
      }
      selectedSlide.hidden = false;
      slideshow.select?.({ id: mediaId }, undefined, { animate: false });
    } else if (option.dataset.image) {
      const image = card.querySelector('[ref="cardGallery"] img');
      if (image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
      }
    }
    if (option.dataset.image) {
      card.dataset.featuredMediaUrl = option.dataset.image;
      const addComponent = this.querySelector('add-to-cart-component');
      if (addComponent) addComponent.dataset.productVariantMedia = option.dataset.image;
    }
  }
}

if (!customElements.get('product-card-purchase')) {
  customElements.define('product-card-purchase', ProductCardPurchase);
}
